import { render, staticRenderFns } from "./StoreTrend.vue?vue&type=template&id=72d912b7&scoped=true&"
import script from "./StoreTrend.vue?vue&type=script&lang=js&"
export * from "./StoreTrend.vue?vue&type=script&lang=js&"
import style0 from "./StoreTrend.vue?vue&type=style&index=0&id=72d912b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d912b7",
  null
  
)

export default component.exports